<template>
<div class="monitor-container">
    <Card class="card-container" dis-hover>
        <div slot="title" class="card-title">压力校准</div>
        <Row type="flex" :gutter="9">
            <Col flex="1">
            <fieldset class="my-fieldset ">
                <legend class="my-legend">压力信息配置</legend>

                <Row type="flex">
                    <Col flex="1">
                    传感器类型
                    </Col>
                    <Col flex="1">
                    <Input type="text" size="small" class="input-field" disabled></Input>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    实时采样值
                    </Col>
                    <Col flex="1">
                    <Input type="text" size="small" class="input-field" disabled></Input>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    压力单位
                    </Col>
                    <Col flex="1">
                    <Input type="text" size="small" class="input-field"></Input>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    倍力
                    </Col>
                    <Col flex="1">
                    <i-switch class="switch-cls" size="small" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    校准点数
                    </Col>
                    <Col flex="1">
                    <Input type="text" size="small" class="input-field"></Input>
                    </Col>
                </Row>

            </fieldset>
            </Col>
            <Col flex="2">
            <fieldset class="my-fieldset ">
                <legend class="my-legend">校准点录入</legend>

                <Row type="flex">
                    <Col flex="1">

                    </Col>
                    <Col flex="1">
                    校准点
                    </Col>

                    <Col flex="1">
                    比例阀输出
                    </Col>

                    <Col flex="1">
                    标准值
                    </Col>
                    <Col flex="1">
                    采样值
                    </Col>

                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    1
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    2
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    3
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    4
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    5
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <Button type="primary">取消</Button>
                    </Col>
                    <Col flex="1">
                    <Button type="primary" @click="handleSave">开始or完成录入</Button>
                    </Col>
                </Row>
            </fieldset>
            </Col>

            <Col flex="1">
            <fieldset class="my-fieldset ">
                <legend class="my-legend">校准系数</legend>

                <Row type="flex">
                    <Col flex="1">
                    校准系数k
                    </Col>
                    <Col flex="1">

                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    校准系数b
                    </Col>
                    <Col flex="1">

                    </Col>
                </Row>
            </fieldset>
            </Col>
        </Row>
    </Card>
    <Card class="card-container" dis-hover>
        <div slot="title" class="card-title">动电极位移校准</div>
        <Row type="flex">
            <Col flex="1">
            分辨率
            </Col>
            <Col flex="1">
            <Input />
            </Col>
        </Row>
    </Card>
    <Card class="card-container" dis-hover>
        <div slot="title" class="card-title">静电极定位销位移校准</div>
        <Row type="flex">
            <Col flex="1">
            <fieldset class="my-fieldset ">
                <legend class="my-legend">校准点录入</legend>

                <Row type="flex">
                    <Col flex="1">

                    </Col>
                    <Col flex="1">
                    校准点
                    </Col>

                    <Col flex="1">
                    标准值 um
                    </Col>
                   
                    <Col flex="1">
                    采样值
                    </Col>

                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    1
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                   
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    2
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                 
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    3
                    </Col>

               

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    4
                    </Col>

                

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <i-switch type="info" />
                    </Col>
                    <Col flex="1">
                    5
                    </Col>

                    <Col flex="1">
                    <InputNumber type="number" />
                    </Col>

                
                    <Col flex="1">
                    <Input type="number" disabled />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    <Button type="primary">取消</Button>
                    </Col>
                    <Col flex="1">
                    <Button type="primary" @click="handleSave">开始or完成录入</Button>
                    </Col>
                </Row>
            </fieldset>
            </Col>
            <Col flex="1">
            <fieldset class="my-fieldset ">
                <legend class="my-legend">校准系数</legend>

                <Row type="flex">
                    <Col flex="1">
                    校准系数k
                    </Col>
                    <Col flex="1">

                    </Col>
                </Row>
                <Row type="flex">
                    <Col flex="1">
                    校准系数b
                    </Col>
                    <Col flex="1">

                    </Col>
                </Row>
            </fieldset>
            </Col>
        </Row>
    </Card>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import {
    int16toBit,
    bitToInt16
} from '@/util/util'

export default {
    name: 'JustifyParam',
    components: {},
    props: {
        systemData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 需要按位编辑的字段列表，后续新增字段只需追加到此数组
            bitFields: [],
            // 原始值快照，保存时对比用
            originalData: {},
            // { HwAssy0: [0,1,0,...], HwAssy1: [...] }
            localBitsMap: {},
            // 需要本地副本的普通值字段（避免直接修改 prop），后续新增字段只需追加到此数组
            valueFields: [],
            // 本地值副本 { HwValveTypePrePrs: val, hwValveTypeTrip: val }
            localData: {}
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),

    },
    created() {
        var self = this
        this.bitFields.forEach(function (field) {
            self.$watch('systemData.' + field, function (newVal) {
                if (newVal != null) {
                    self.$set(self.localBitsMap, field, int16toBit(newVal))
                    self.$set(self.originalData, field, newVal)
                }
            }, {
                immediate: true
            })
        })
        this.valueFields.forEach(function (field) {
            self.$watch('systemData.' + field, function (newVal) {
                self.$set(self.localData, field, newVal)
                self.$set(self.originalData, field, newVal)
            }, {
                immediate: true
            })
        })
    },
    methods: {
        handleSave() {
            var payload = {}
            var self = this
            this.bitFields.forEach(function (field) {
                var bits = self.localBitsMap[field]
                if (!bits) return
                var newVal = bitToInt16(bits)
                if (newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            this.valueFields.forEach(function (field) {
                var newVal = self.localData[field]
                if (newVal != null && newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            if (Object.keys(payload).length > 0) {
                this.$emit('save', payload)
            } else {
                this.$Message.error(this.getTranslation('a159'))
            }
        }
    },
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.multi-row {
    margin-top: 10px;
}
</style>
